export default "__VITE_ASSET__53f636e1__"